module.exports = __webpack_public_path__ + "static/personRow@2x-6a325339156da1250e5cf9cc227b3ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/personRow@2x.jpg
// module id = 2583
// module chunks = 168707334958949